import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// CBOps redesign design tokens (--p-* vars + .p-* helpers). Imported once
// here per the design system. Source of truth: references/pulse-theme.css.
import './styles/pulse-theme.css';
// The 12 fixed background looks (--cb-bg) + the fixed background layers.
import './styles/looks.css';
// Light-mode readability: light-only rules for hardcoded white/teal text. Every
// selector is scoped to html[data-theme='light'], so dark mode cannot change.
import './styles/lightReadability.css';
// CRM drawer styles (.drw-*). Imported once here — importing from lazy CRM
// chunks caused a webpack "Conflicting order" warning.
import './components/crm/DrawerRedesign.css';
// Initialise i18next before rendering — sets locale, direction, and language detection
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Dev-only: silence ONE benign browser warning ───────────────────────────
// "ResizeObserver loop completed with undelivered notifications" is a non-fatal
// notice Chrome fires when a resize callback defers work to the next frame. In
// this app it's triggered by the drawer-close reflow bumping existing
// ResizeObservers (grid-layout / Recharts / Configure popovers) — nothing
// actually breaks, but CRA's error overlay pops on every drawer close, which is
// noise that also risks masking real errors.
//
// This suppresses ONLY that exact message, and ONLY in development:
//   • Exact-string match — the different "...loop limit exceeded" message (which
//     can signal a REAL runaway loop) is deliberately NOT matched and still shows.
//   • NODE_ENV-gated — production error handling is completely untouched (the
//     overlay doesn't exist in prod anyway).
//   • No try/catch, no broad swallowing — it stops propagation for this one
//     window 'error' event and nothing else.
if (process.env.NODE_ENV === 'development') {
  const RO_MSG = 'ResizeObserver loop completed with undelivered notifications';
  window.addEventListener('error', (e) => {
    if (e.message === RO_MSG) {
      e.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
